import { api } from "@/lib/api";

export type NotificationKind =
  | "task_review"
  | "task_blocked"
  | "task_done"
  | "routine_created_task"
  | "budget_warning"
  | "system";

export type Notification = {
  id: string;
  companyId: string;
  userId: string | null;
  kind: NotificationKind;
  title: string;
  body: string | null;
  linkUrl: string | null;
  readAt: string | null;
  createdAt: string;
};

export const notificationsApi = {
  list: (
    companyId: string,
    options: { onlyUnread?: boolean; limit?: number } = {},
  ) => {
    const params = new URLSearchParams();
    if (options.onlyUnread) params.set("onlyUnread", "true");
    if (options.limit) params.set("limit", String(options.limit));
    const qs = params.toString();
    return api.get<Notification[]>(
      `/companies/${companyId}/notifications${qs ? `?${qs}` : ""}`,
    );
  },
  unreadCount: (companyId: string) =>
    api.get<{ count: number }>(
      `/companies/${companyId}/notifications/unread-count`,
    ),
  markRead: (id: string) =>
    api.post<void>(`/notifications/${id}/read`, {}),
  markAllRead: (companyId: string) =>
    api.post<{ count: number }>(
      `/companies/${companyId}/notifications/read-all`,
      {},
    ),
};
